export type ApiTimestampFormat = "date" | "datetime";

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const parseApiTimestamp = (value?: string | null): Date | null => {
  if (!value || DATE_ONLY_PATTERN.test(value)) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatApiTimestamp = (
  value?: string | null,
  format: ApiTimestampFormat = "date",
  fallback = "--",
): string => {
  if (!value) return fallback;
  if (DATE_ONLY_PATTERN.test(value)) return value.replace(/-/g, "/");

  const parsed = parseApiTimestamp(value);
  if (!parsed) return fallback;

  return new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...(format === "datetime"
      ? { hour: "2-digit", minute: "2-digit", hour12: false }
      : {}),
  }).format(parsed);
};
